import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllBaixaManualEstoqueProducao } from '../service';
import {
  LIST_BAIXAR_MANUAL_ESTOQUE_PRODUCAO,
  LIST_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_PENDING,
  LIST_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_SUCCESS,
  LIST_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_FAILURE
} from '../actionTypes';

function* sagaListAllBaixaManualEstoqueProducao(action) {
  yield put({ type: LIST_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_PENDING })

  try {
    const list = yield call(findAllBaixaManualEstoqueProducao)
    
    yield put({ type: LIST_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_SUCCESS, list: list })
  } catch (error) {

    yield put({ type: LIST_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllBaixaManualEstoqueProducao() {
  yield takeLatest(LIST_BAIXAR_MANUAL_ESTOQUE_PRODUCAO, sagaListAllBaixaManualEstoqueProducao)
}